import { Column } from "components/Table/Simple";
import { infoService } from "common/services/info";
import { booleanColumnOptions } from "components/Table/Simple/presets";

export const columns: Column[] = [
    {
        field: "id",
        label: "고유번호",
    },
    {
        field: "user_id",
        label: "아이디",
        creatable: true,
        editable: true,
    },
    {
        field: "user_type",
        label: "사용자 유형",
    },
    {
        field: "clinic_id",
        label: "의원",
        creatable: true,
        editable: true,
        selectable: {
            getOptions: () => {
                const options = infoService.getClinics()?.map((clinic) => (
                    { name: clinic.name, value: clinic.id }
                ))
                return options;
            }
        },
        render: (value, field, row) => row.clinic?.name ?? ""
    },
    {
        field: "clinic",
        label: "의원",
        visible: false
    },
    {
        field: "name",
        label: "이름",
        creatable: true,
        editable: true
    },
    {
        field: "password_reset_required",
        label: "비밀번호 초기화 필요",
        align: "center",
        editable: true,
        ...booleanColumnOptions
    },
]